import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Modal,
  Paper,
  TextField,
  Typography,
  Autocomplete,
  InputAdornment,
} from "@mui/material";

import { HowToReg } from "@mui/icons-material";

import { useNotification } from "../../../../componentes/notificationProvider";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import { validarEmail, validarSenha } from "../../../../utils/validateFields";
import { LoadingButton } from "@mui/lab";
import {
  RowsData,
  Permissions,
} from "../../../../componentes/administracao/types";
import { AxiosError } from "axios";

interface ModalCreateProps {
  openCreateUserModal: boolean;
  setOpenCreateUserModal: (value: boolean) => void;
  permissoes: Permissions;
  pagePermission: [];
  role?: string;
  rows: RowsData[] | [];
  selectedRow: RowsData;
  setRows: React.Dispatch<React.SetStateAction<RowsData[]>>;
}

interface Permissao {
  value: string;
  name: string;
}

interface PagePermission {
  id: string;
  title: string;
}
const ModalCreateUser: React.FC<ModalCreateProps> = (params) => {
  const {
    openCreateUserModal,
    setOpenCreateUserModal,
    permissoes,
    pagePermission,
    role,
    rows,
    setRows,
    selectedRow,
  } = params;
  const notify = useNotification();
  const isSuperAdmin = role === "adm001";
  const [selectedPermissoes, setSelectedPermissoes] =
    useState<Permissao | null>(null);

  const [selectedPagePermission, setSelectedPagePermission] = useState<
    PagePermission[]
  >([]);

  const [id, setId] = useState<string>("");
  const [cadastroSenha, setCadastroSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [cadastroEmail, setCadastroEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const styles = {
    modal: { display: "flex", justifyContent: "center", alignItems: "center" },
    paper: {
      padding: 2,
      maxWidth: "432px",
      width: "90%",
      minWidth: "232px",
      maxHeight: "90vh",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "felx-start",
    },
    formControl: {
      width: "100%",
      marginTop: "12px",
    },
    boxTitle: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "start",
      alignItems: "center",
      color: "primary.main",
      width: "100%",
    },
    subtitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: "text.primary",
    },
    dialogTitle: {
      padding: 0,
    },
    dialogActions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
      gap: 0,
      padding: 0,
      width: "100%",
    },
    dialogContent: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: 0,
      gap: 1.5,
    },
    boxRowFields: {
      display: "flex",
      flexDirection: "column",
      with: "100%",
      gap: 1,
    },
    boxPasswords: {
      display: "flex",
      flexDirection: "column",
      with: "100%",
      gap: 2,
    },
    textfield: {
      width: "100%",
    },
    boxHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      mb: 1,
    },
  };

  useEffect(() => {
    setId(String(selectedRow?.id));
  }, [selectedRow]);

  async function handleApiNovoUsuario() {
    setIsSubmit(true);
    if (
      !cadastroEmail ||
      !cadastroSenha ||
      !confirmarSenha ||
      confirmarSenha !== cadastroSenha ||
      !selectedPermissoes?.value ||
      !selectedPagePermission?.length ||
      !validarEmail(cadastroEmail) ||
      !validarSenha(cadastroSenha)
    )
      return;
    try {
      setLoading(true);
      const pagePermissionId = selectedPagePermission.map((item) => item.id);
      const response = await api.post("/admin/createUser", {
        senha: cadastroSenha,
        email: cadastroEmail,
        logsLoginClienteId: JSON.parse(String(localStorage.getItem("logs"))).id,
        codigoPermissao: selectedPermissoes.value,
        pagePermissionIds: pagePermissionId,
      });

      if (response.data) {
        setRows([...(rows || []), response.data]);
        handleClose();
        notify(null, "Dados salvos com sucesso!", "success");
      }
    } catch (error: any) {
      console.log(error);
      if (error instanceof AxiosError && error?.response?.data && error.status)
        notify(error?.status || 500, undefined, "error", error);
      else notify(null, "Erro ao criar novo usuário!", "error");
    } finally {
      setLoading(false);
    }
  }

  const handleClose = () => {
    setOpenCreateUserModal(false);
    setCadastroEmail("");
    setCadastroSenha("");
    setSelectedPermissoes(null);
    setShowPassword(false);
    setShowConfirmPassword(false);
    setConfirmarSenha("");
    setIsSubmit(false);
  };

  const handleClickShowPassword = (type: "password" | "confirmPassword") => {
    if (type === "password") {
      setShowPassword((show) => !show);
    } else {
      setShowConfirmPassword((show) => !show);
    }
  };

  const handleMouseDownPassword = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    event.preventDefault();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleApiNovoUsuario();
    }
  };

  const handleValidateEmail = () => {
    const verificaEmail = rows?.some(
      (row: RowsData) => cadastroEmail === row?.email && row.id !== id,
    );
    if (verificaEmail) {
      return true;
    }
    return false;
  };

  return (
    <Modal
      open={openCreateUserModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={styles.modal}
    >
      <Paper sx={styles.paper}>
        <DialogTitle sx={styles.dialogTitle} color="primary.main">
          <Box sx={styles.boxHeader}>
            <Box sx={styles.boxTitle}>
              <IconButton size="small">
                <HowToReg sx={{ color: "primary.main" }} />
              </IconButton>
              <Typography fontWeight={500}>Cadastrar Usuário</Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={() => {
                setOpenCreateUserModal(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Grid container columnSpacing={1.5} rowSpacing={2}>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Box sx={styles.boxRowFields}>
                {/* <Typography sx={styles.subtitle}>Email</Typography>{" "} */}
                <TextField
                  size="small"
                  id="outlined-adornment-email"
                  type="email"
                  autoComplete="off"
                  value={cadastroEmail}
                  onChange={(e) => setCadastroEmail(e.target.value)}
                  label="Email"
                  variant="filled"
                  error={
                    (isSubmit &&
                      (!cadastroEmail || !validarEmail(cadastroEmail))) ||
                    handleValidateEmail()
                  }
                  helperText={
                    (isSubmit &&
                      (!cadastroEmail || !validarEmail(cadastroEmail)) &&
                      "Formato de Email inválido") ||
                    (handleValidateEmail() && "Este email já está cadastrado!")
                  }
                  disabled={loading}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Box sx={styles.boxRowFields}>
                <Autocomplete
                  id="multiple-limit-tags"
                  size="small"
                  value={selectedPermissoes}
                  onChange={(e, value: Permissao | null) =>
                    setSelectedPermissoes(value)
                  }
                  options={
                    Array.isArray(permissoes) ? (permissoes as Permissao[]) : []
                  }
                  getOptionLabel={(option: Permissao) => option.name}
                  getOptionDisabled={(option: Permissao) =>
                    !isSuperAdmin ? option.value === "adm001" : false
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Permissões"
                      variant="filled"
                      sx={styles.textfield}
                      error={isSubmit && !selectedPermissoes?.value}
                      helperText={
                        isSubmit &&
                        !selectedPermissoes?.value &&
                        "Campo obrigatório"
                      }
                    />
                  )}
                  disabled={loading}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Box sx={styles.boxRowFields}>
                <Autocomplete
                  id="multiple-limit-tags"
                  multiple
                  size="small"
                  value={selectedPagePermission}
                  onChange={(e, value: any) => {
                    if (value.some((v: any) => v.id === "all")) {
                      if (
                        selectedPagePermission.length === pagePermission.length
                      ) {
                        setSelectedPagePermission([]);
                      } else {
                        setSelectedPagePermission(pagePermission);
                      }
                    } else {
                      setSelectedPagePermission(value);
                    }
                  }}
                  options={[
                    { id: "all", title: "Selecionar Todos" },
                    ...pagePermission,
                  ]}
                  getOptionLabel={(option: any) => option.title}
                  disableCloseOnSelect
                  // getOptionDisabled={(option: Permissao) =>
                  //   !isSuperAdmin ? option.value === "adm001" : false
                  // }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Permissões de páginas"
                      variant="filled"
                      sx={styles.textfield}
                      //placeholder="Nível de acesso"
                      error={isSubmit && selectedPagePermission.length === 0}
                      helperText={
                        isSubmit &&
                        selectedPagePermission.length === 0 &&
                        "Campo obrigatório"
                      }
                    />
                  )}
                  disabled={loading}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Box sx={styles.boxPasswords}>
                <TextField
                  size="small"
                  id="input-senha"
                  label="Senha"
                  variant="filled"
                  type={showPassword ? "text" : "password"}
                  autoComplete="off"
                  value={cadastroSenha}
                  onChange={(e) => setCadastroSenha(e.target.value)}
                  slotProps={{
                    input: {
                      autoComplete: "new-password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            edge="end"
                            onClick={() => handleClickShowPassword("password")}
                            onMouseDown={() => handleMouseDownPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  error={
                    isSubmit && (!cadastroSenha || !validarSenha(cadastroSenha))
                  }
                  helperText={
                    isSubmit &&
                    (!cadastroSenha || !validarSenha(cadastroSenha)) &&
                    "A senha tem que ter no mínimo 6 dígitos e uma letra maiúscula"
                  }
                  disabled={loading}
                />
                <TextField
                  size="small"
                  id="input-confirmar-senha"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmarSenha}
                  variant="filled"
                  label="Confirmar Senha"
                  onKeyDown={handleKeyDown}
                  autoComplete="off"
                  onChange={(e) => setConfirmarSenha(e.target.value)}
                  slotProps={{
                    input: {
                      autoComplete: "new-password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            edge="end"
                            onClick={() =>
                              handleClickShowPassword("confirmPassword")
                            }
                            onMouseDown={() => handleMouseDownPassword}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  error={
                    isSubmit &&
                    ((cadastroSenha && !confirmarSenha) ||
                      cadastroSenha !== confirmarSenha)
                  }
                  helperText={
                    isSubmit &&
                    ((cadastroSenha && !confirmarSenha) ||
                      cadastroSenha !== confirmarSenha) &&
                    "As senhas não conferem!"
                  }
                  disabled={loading}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
          <Button
            sx={{ color: "primary.main" }}
            onClick={handleClose}
            variant="text"
            disabled={loading}
          >
            Cancelar
          </Button>
          <LoadingButton
            onClick={handleApiNovoUsuario}
            variant="contained"
            loading={loading}
          >
            Salvar
          </LoadingButton>
        </DialogActions>
      </Paper>
    </Modal>
  );
};

export default ModalCreateUser;
